import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function MenHub() {
  return (
    <>
      <Helmet defer={false}>
        <title>Men's Hormone Health by Decade | Hormonely</title>
        <meta name="description" content="Hormone health guides for men in their 40s, 50s and 60s. Plain English information about testosterone decline, andropause and what to do about it." />
      </Helmet>

      <div className="page-hero">
        <div className="container page-hero__inner">
          <div className="eyebrow" style={{ color: 'var(--clay-lt)', marginBottom: '16px' }}>Men</div>
          <h1 className="page-hero__title">Your hormones by <em>decade</em></h1>
          <p className="page-hero__sub">Plain English guides to what's actually happening to your hormones — and what to do about it. Start with the decade that matches where you are now.</p>
        </div>
      </div>

      <section className="section section--white">
        <div className="container">
          <div className="guides-grid">
            <Link to="/men-30s" className="guide-card">
              <span className="guide-card__decade">30s</span>
              <div className="guide-card__title">Men in their 30s</div>
              <div className="guide-card__topics">Testosterone starts declining, cortisol and stress, sleep hormones and fertility</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/men-40s" className="guide-card">
              <span className="guide-card__decade">40s</span>
              <div className="guide-card__title">Men in their 40s</div>
              <div className="guide-card__topics">Testosterone decline, andropause, energy, body composition, mood and libido</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/men-50s" className="guide-card">
              <span className="guide-card__decade">50s</span>
              <div className="guide-card__title">Men in their 50s</div>
              <div className="guide-card__topics">When your GP says you're fine and you're not. TRT, thyroid and cardiovascular health</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/men-60s" className="guide-card">
              <span className="guide-card__decade">60s</span>
              <div className="guide-card__title">Men in their 60s</div>
              <div className="guide-card__topics">Maintaining health and quality of life. TRT, cardiovascular risk, muscle mass and sleep apnoea</div>
              <span className="guide-card__arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
